import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl, price, priceValue, productName } from '../data/copy';
import { trackPixelEvent } from '../utils/metaPixel';

/**
 * Always-available purchase shortcut on small screens: appears once the hero
 * is scrolled past and hides over the offer section.
 *
 * Visibility is driven by IntersectionObserver (no layout reads on scroll).
 */
export function StickyCta() {
  const [isPastHero, setIsPastHero] = useState(false);
  const [isOnOffer, setIsOnOffer] = useState(false);
  useEffect(() => {
    const hero = document.querySelector('header');
    const offer = document.getElementById('offer');
    const heroObserver = new IntersectionObserver(([entry]) => setIsPastHero(!entry.isIntersecting), {
      threshold: 0
    });
    if (hero) heroObserver.observe(hero);
    const offerObserver = new IntersectionObserver(([entry]) => setIsOnOffer(entry.isIntersecting), {
      threshold: 0
    });
    if (offer) offerObserver.observe(offer);
    return () => {
      heroObserver.disconnect();
      offerObserver.disconnect();
    };
  }, []);
  const isVisible = isPastHero && !isOnOffer;
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-4 shadow-[0_-8px_24px_rgba(0,26,77,0.08)] backdrop-blur py-3 transition-[opacity,transform] duration-200 ease-out sm:hidden ${isVisible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-3 opacity-0'}`} data-id="element-242" data-mp="gvfc4m5o8p67">
      <a href={checkoutUrl} onClick={() => trackPixelEvent('InitiateCheckout', {
      content_name: productName,
      value: priceValue,
      currency: 'USD'
    })} className="flex w-full items-center justify-center gap-2.5 rounded-full bg-gold px-6 py-3.5 font-sans text-sm font-extrabold uppercase tracking-wide text-navy transition-colors duration-150 ease-out hover:bg-gold-soft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-243" data-mp="lvbe6fut66j4">
        Get the system — {price}
        <ArrowRightIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-244" data-mp="10l03m1g4q8bh" />
      </a>
    </div>;
}